import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import $ from "jquery";

/* import "~/Assets/css/heremap/mapsjs-ui.css";
import 'https://js.api.here.com/v3/3.0/mapsjs-core.js';
import 'https://js.api.here.com/v3/3.0/mapsjs-service.js';
import 'https://js.api.here.com/v3/3.0/mapsjs-ui.js';
import 'https://js.api.here.com/v3/3.0/mapsjs-mapevents.js';
import 'https://js.api.here.com/v3/3.0/mapsjs-clustering.js'; */

export class OMSHereMapLocation extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    style: PropTypes.object,
    onChange: PropTypes.func,
    onGetInfo: PropTypes.func,
    loadMap: PropTypes.bool,
  };

  state = {
    lat: 0,
    long: 0,
  };

  componentDidMount() {
    if (this.props.loadMap) this.loadMap();
  }

  loadMap = () => {
    const H = window.H;
    var mapContainer = document.getElementById("map");

    var APPLICATION_ID = "fF44c0Lf6GzCoeb27d64";
    var APPLICATION_CODE = "vrzOQWmJLkGyzTMK74n12w";

    //var APPLICATION_ID = '7oM7HUWgX8ouW2Ehe0m2';
    //var APPLICATION_CODE = 'T7OsnFL0cXetB-J-VbDhrQ';

    if (this.platform === undefined) {
      var platform = new H.service.Platform({
        app_id: APPLICATION_ID,
        app_code: APPLICATION_CODE,
        useCIT: false, // true
        useHTTPS: true,
      });

      var defaultLayers = platform.createDefaultLayers();
      var geocoder = platform.getGeocodingService();
      //var group = new H.map.Group();
      /*group.addEventListener('tap', function (evt) {
              this.map.setCenter(evt.target.getPosition());
              this.openBubble(evt.target.getPosition(), evt.target.getData());
            }.bind(this), false); */

      var ct = { lat: -25.85804, lng: 28.18966 }; //SA

      var map = new H.Map(mapContainer, defaultLayers.normal.map, {
        center: ct,
        zoom: 3,
        pixelRatio: window.devicePixelRatio || 1,
      });

      //map.addObject(group);
      var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
      // Create the default UI components
      var ui = H.ui.UI.createDefault(map, defaultLayers);

      this.platform = platform;
      this.geocoder = geocoder;
      this.ui = ui;
      this.map = map;
      //this.group = group;
      this.behavior = behavior;
    }
  };

  handleLocationChange = (lat, long) => {
    var reverseGeocodingParameters = {
      prox: lat + "," + long + ",50",
      mode: "retrieveAddresses",
      maxresults: "1",
    };
    this.geocoder.reverseGeocode(reverseGeocodingParameters, this.onGeocodeSuccess, this.onGeocodeError);
  };

  handleLocationIDChange = (locationid) => {
    this.geocoder.geocode({ locationId: locationid }, this.onGeocodeSuccess, this.onGeocodeError);
  };

  handleLocationOnlyChange = (lat, long) => {
    if (this.platform === undefined) this.loadMap();

    this.addDraggableMarker(lat, long);
  };

  onGeocodeSuccess = (result) => {
    if (result !== undefined && result.Response !== undefined && result.Response.View != undefined && result.Response.View != null) {
      if (result.Response.View.length > 0 && result.Response.View[0].Result !== undefined && result.Response.View[0].Result.length > 0) {
        var resultLocation = result.Response.View[0].Result[0];
        this.addDraggableMarker(resultLocation.Location.DisplayPosition.Latitude, resultLocation.Location.DisplayPosition.Longitude);
        var address = resultLocation.Location.Address;
        var selected = {
          propertyNumber: "",
          streetName: "",
          suburb: "",
          town: "",
          province: "",
          country: "",
          postalcode: "",
          lat: 0,
          long: 0,
        };
        selected.lat = resultLocation.Location.DisplayPosition.Latitude;
        selected.long = resultLocation.Location.DisplayPosition.Longitude;

        if (address.Country == "NAM") {
          if (address.HouseNumber !== undefined) selected.propertyNumber = address.HouseNumber;

          if (address.Street !== undefined) selected.streetName = address.Street;

          if (address.District !== undefined) {
            selected.suburb = address.District;

            if (address.City !== undefined) selected.town = address.City;
            else if (address.County !== undefined) selected.town = address.County;
          } else {
            if (address.County !== undefined) selected.town = address.County;

            if (address.City !== undefined) selected.suburb = address.City;
          }

          if (address.State !== undefined) selected.province = address.State;

          selected.country = "Namibia";
        } else {
          if (address.HouseNumber !== undefined) selected.propertyNumber = address.HouseNumber;

          if (address.Street !== undefined) selected.streetName = address.Street;

          if (address.District !== undefined) selected.suburb = address.District;

          if (address.City !== undefined) selected.town = address.City;
          else if (address.County !== undefined) selected.town = address.County;

          if (address.State !== undefined) selected.province = address.State;

          if (address.Country == "SYC")
                        selected.country = "Seychelles";
                    else if (address.Country == "CYP")
                        selected.country = "Cyprus";
                    else
                        selected.country = "South Africa";
        }

        if (address.PostalCode !== undefined) selected.postalcode = address.PostalCode;

        if (this.props.onGetInfo !== undefined) this.props.onGetInfo(selected);
      }
    }
  };

  onGeocodeError = (error) => {
    alert(error);
  };

  addDraggableMarker = (lat, long) => {
    const H = window.H;

    if (lat === undefined || lat == "0" || long === undefined || long == "0") {
      var ct = { lat: -25.85804, lng: 28.18966 }; //SA
      this.map.getViewPort().resize();
      this.map.setZoom(15);
      this.map.setCenter(ct);
      return;
    }

    if (this.marker === undefined) {
      var marker = new H.map.Marker({ lat: lat, lng: long });
      marker.draggable = true;
      this.map.addObject(marker);
      this.marker = marker;

      this.map.getViewPort().resize();
      this.map.setZoom(15);
      this.map.setCenter({ lat: lat, lng: long });

      // disable the default draggability of the underlying map
      // when starting to drag a marker object:
      this.map.addEventListener(
        "dragstart",
        function (ev) {
          var target = ev.target;
          if (target instanceof H.map.Marker) {
            this.behavior.disable();
          }
        }.bind(this),
        false
      );

      this.map.addEventListener(
        "dragend",
        function (ev) {
          var target = ev.target;
          if (target instanceof H.map.Marker) {
            this.behavior.enable();
            var location = target.getPosition();
            this.map.setCenter(location);
            this.setState({ lat: location.lat, long: location.long });
            if (this.props.onChange !== undefined) this.props.onChange(location.lat, location.lng);
          }
        }.bind(this),
        false
      );

      this.map.addEventListener(
        "drag",
        function (ev) {
          var target = ev.target,
            pointer = ev.currentPointer;
          if (target instanceof H.map.Marker) {
            target.setPosition(this.map.screenToGeo(pointer.viewportX, pointer.viewportY));
          }
        }.bind(this),
        false
      );
    } else {
      if (this.marker instanceof H.map.Marker) {
        var point = new H.geo.Point(lat, long);
        this.marker.setGeometry(point);
        this.map.getViewPort().resize();
        this.map.setCenter({ lat: lat, lng: long });
      }
    }

    if (this.props.onChange !== undefined) this.props.onChange(lat, long);
  };

  render() {
    return <div id="map" style={this.props.style}></div>;
  }
}
